type Books = {[key: string]:  string};
export const books: Books = { psalms: "Psalms", proverbs: "Proverbs" };
